import React from 'react';
import PropTypes from 'prop-types';
import { StyledTitle } from './style';

const Title = ({ children, className }) => (
  <StyledTitle className={className}>{children}</StyledTitle>
);

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Title;
